import { inject as n } from "vue";
function e() {
  return n("dsI18n");
}
export {
  e as default
};
//# sourceMappingURL=design-system.es116.js.map
